//=====================================================
//　ユーザー認証
//=====================================================
import { AxiosResponse } from 'axios';
import { postApiData, getApiDataWithToken } from './CallApi';


//ユーザー認証管理IF
export interface IFUseAuth { 
    login: ( id:string, password:string, callback?:any ) => void,
    logout: (callback?:any) => void,
    getToken: () => string | null,
    getOperatorNo: () => string | null,
    isLoggedIn: (callback?:any) => void,
}

//-----------------------------------------------------
//　ユーザー認証管理
//-----------------------------------------------------
export function useAuth():IFUseAuth{
    
    //-----------------------------------------------------
    //　ログイン
    //-----------------------------------------------------
    function login( operator_id: string, password: string, callback?: any){
        let apiUrl = `/management/login`;
        postApiData(
            apiUrl, 
            {operator_id:operator_id, password:password}, 
            function(res:AxiosResponse<any>){
                if(res.status === 200 ){
                    sessionStorage.setItem('operator_id', res.data.operator_id);
                    sessionStorage.setItem('access_token', res.data.access_token);
                    sessionStorage.setItem('refresh_token', res.data.refresh_token);
                    sessionStorage.setItem('expiresIn', res.data.access_exp);
                }
                if (callback){
                    callback(res);
                }
            }
        );
    }

    //-----------------------------------------------------
    //　ログアウト
    //-----------------------------------------------------
    function logout(callback?: any) {
        sessionStorage.removeItem('operator_id');
        sessionStorage.removeItem('access_token');
        sessionStorage.removeItem('refresh_token');
        sessionStorage.removeItem('expiresIn');
        if (callback){
            callback();
        }
    }
    
    //-----------------------------------------------------
    //　セッションストレージに保持したトークンの取得
    //-----------------------------------------------------
    function getToken(){
        //保持期間を判定
        const dt = new Date(new Date().toUTCString()).getTime();
        const expiresIn = new Date(String(sessionStorage.getItem('expiresIn'))).getTime();
        if( dt > expiresIn ){
            //アクセストークン保存期間切れ
            //リフレッシュトークンを使用
            return sessionStorage.getItem('refresh_token');
        }
        return sessionStorage.getItem('access_token');
    }

    //-----------------------------------------------------
    //　セッションストレージに保持した管理者ID
    //-----------------------------------------------------
    function getOperatorNo() {
        return sessionStorage.getItem('operator_id');
    }

    //-----------------------------------------------------
    //　ログイン済みかの判定
    //-----------------------------------------------------
    function isLoggedIn(callback?: any) {
        let apiUrl = `/management/refresh`;
        getApiDataWithToken(
            apiUrl,
            {},
            getToken(),
            function(res:AxiosResponse<any>){
                switch (res.status){
                    case 200:
                        //リフレッシュトークンの有効期限内
                        //アクセストークン更新
                        sessionStorage.setItem('access_token', res.data.access_token);
                        sessionStorage.setItem('expiresIn', res.data.access_exp);
                        //ログイン済
                        callback(true);
                        break;
                    default://400
                        sessionStorage.removeItem('operator_id');
                        sessionStorage.removeItem('access_token');
                        sessionStorage.removeItem('refresh_token');
                        sessionStorage.removeItem('expiresIn');
                        //リフレッシュトークンの有効期限外または未ログイン
                        callback(false);
                        break;
                }
            }
        );
    }

    return {login, logout, getToken, getOperatorNo, isLoggedIn};

}